import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { iInterpreterResultState, iInterpreterResult } from 'store/types/interpreter';

export const initialState: iInterpreterResultState = {
    interpreterResult: null
};

export const interpreterResultSlice = createSlice({
  name: 'interpreterResult',
  initialState,
  reducers: {
    setInterpreterResult: (state, action: PayloadAction<iInterpreterResult>) => {
      // Replace the entire assembly state
        const interpreterResult: iInterpreterResult = action.payload
        state.interpreterResult = interpreterResult
    },
    resetInterpreterResult: (state) => {
      state.interpreterResult = null
    }
  }
});

// The exported reducer
export default interpreterResultSlice.reducer;
// Export the action
export const { setInterpreterResult, resetInterpreterResult } =interpreterResultSlice.actions;
// Optional selector
export const interpreterResultSelector = (state: RootState) =>
    state.interpreterResult.interpreterResult;